var BaseViews = require('../../../../base');
require('./search-filters-item/search-filters-item.scss');
var SearchFiltersItem = BaseViews.ItemView.extend({
    className: function () {
      if (this.options.totalItems == 4) {
        return 'fmcy-search-filters-item col-xs-3 col-md-2  fmcy-category-menu-item';
      } else {
        return 'fmcy-search-filters-item col-xs-4 col-md-2  fmcy-category-menu-item';
      }
    },
    template: require('./search-filters-item/search-filters-item.html'),
    events: {
        click: 'categoryClicked'
    },
    onRender: function() {
        if (this.options.style) {
            this.$el.addClass(this.options.style);
        }
        if (this.options.childIndex > 5) {
            this.$el.addClass('fmcy-top-spacer');
        }
    },
    categoryClicked: function() {
        this.trigger('filter:clicked');
    },
    setActive: function() {
        this.$el.addClass('active');
    },
    reset: function() {
        this.$el.removeClass('active');
    },
    serializeData: function() {
        var iconClass = 'fmcy-menu-category-item-icon-default';

        return {
            name: this.model.get('name'),
            iconclass: iconClass
        };
    }
});

module.exports = SearchFiltersItem;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/subfilters/search-filters/search-filter-tabs/search-filters-item.js
 **/